import * as React from 'react'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface Props {
  title: string;
  description: React.ReactNode;
  icon: React.ReactNode;
  tabletIcon: React.ReactNode;
}

function CharterBundleModalUspItem(props: Props) {
  return <>
    <CSSBreakpoint max="mobile">
      <BodyTextBlock
        variant="medium"
        startIcon={props.icon}
      >
        <BodyTextBlock variant="medium" weight="bold">
          {props.title}
        </BodyTextBlock>
        {props.description}
      </BodyTextBlock>
    </CSSBreakpoint>
    <CSSBreakpoint min="tablet">
      <VerticalSpacer gap={12}>
        {props.tabletIcon}
        <VerticalSpacer gap={4}>
          <BodyTextBlock variant="large" weight="bold">
            {props.title}
          </BodyTextBlock>
          <BodyTextBlock variant="medium">
            {props.description}
          </BodyTextBlock>
        </VerticalSpacer>
      </VerticalSpacer>
    </CSSBreakpoint>
  </>
}

export default CharterBundleModalUspItem
